<template>
  <div>
    <header>
      <a
        class="link-site"
        :href="cashbackCompareUrl"
      >
        Back to Compare
      </a>
      <div
        class="logo"
        :style="{
          'background-image': `url(${config.partnerImage || baseUrl + '/images/gecko-images/tcb-logo-brand.png'})`,
        }"
      />
    </header>

    <div class="section-bg">
      <section class="header-content site-width">
        <div class="hero-text">
          <p class="title">Compare {{ productName }} Insurance </p>
          <p
            class="heading"
            v-html="cashbackHeadingText"
          />
        </div>
        <img
          :src="`https://s3.eu-west-1.amazonaws.com/cdn.seopa.com/img/tcb/compare-${productName}-insurance.webp`"
          :alt="productName"
          class="category"
          :class="`${productName}-logo-image`"
        >
      </section>
    </div>

    <div class="section-bg section-breadcrumbs">
      <section class="navbar site-width">
        <div class="breadcrumbs">
          <a :href="cashbackCompareUrl">Compare</a>
          <span>{{ productName }} Insurance Compare</span>
        </div>
        <a
          :href="`${cashbackCompareUrl}/quotes/${productName}`"
          class="retrieve-quote"
        >
          Retrieve a previous quote
        </a>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tcb-partner-header',
  inject: ['config', 'productName'],
  data () {
    return {
      baseUrl: 'https://www.topcashback.co.uk',
    };
  },
  computed: {
    cashbackCompareUrl () {
      return `${this.baseUrl}/topcashback-compare`;
    },
    cashbackAmount () {
      const CASHBACK = {
        van: '38',
        bike: '26',
        pet: '27',
        travel: '20.07',
      };

      return CASHBACK?.[this.productName] || 0;
    },
    cashbackHeadingText () {
      if (['travel'].includes(this.productName)) {
        return `<span class="font-weight-bold">Get up to £${this.cashbackAmount}</span> cashback on your ${this.productName} insurance`;
      }

      return `<span class="font-weight-bold">Get £${this.cashbackAmount}</span> cashback on your ${this.productName} insurance policy`;
    },
  },
};
</script>

<style lang="scss" scoped src="@/assets/scss/header/tcb-compare-header.scss"/>
